// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import productDescriptionVariantStyles from "@sc/App/SharedStyles/ProductDescriptionStyles";
import { productGridCardStyles } from "@sc/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { color, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productGridCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: 376px;
            padding: 12px;
            border: 1px solid ${color("common.border")};
            border-radius: 4px;

            ${xScreen("lte", "lg")} {
                max-width: 317px;
            }
        `,
    },
};

productGridCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                margin-top: auto;
                &.pricing-info-container {
                    margin-top: 50px;
                    margin-bottom: 12px;
                }
                &:empty {
                    display: none;
                }
            `,
        },
    },
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
            margin-bottom: 12px;
        `,
    },
    compareCheckbox: {
        css: css`
            margin: 0;
            padding: 0;
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                height: 352px;
                position: relative;
                width: 100%;
                ${xScreen("lte", "lg")} {
                    height: 293px;
                }
            `,
        },
        img: {
            width: 301,
            height: 301,
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
                object-fit: contain;
            `,
        },
    },
};

productGridCardStyles.productInformationStyles = {
    descriptionStyles: {
        ...mergeWithCss(productDescriptionVariantStyles.medium, {
            productDetailLink: {
                css: css`
                    min-height: 32px;
                    ${xScreen("lte", "lg")} {
                        min-height: 48px;
                    }
                `,
            },
        }),
    },
};
